import { isNLD_OR_LL } from 'common/constants/app.constants';
import { FILTER_TYPES } from '../../constants';

export const defaultDataPerPageOptions = [
  { displayName: 'Show 10 Rows', key: '10' },
  { displayName: 'Show 20 Rows', key: '20' },
  { displayName: 'Show 30 Rows', key: '30' },
  { displayName: 'Show 40 Rows', key: '40' },
  { displayName: 'Show 50 Rows', key: '50' },
  { displayName: 'Show 60 Rows', key: '60' },
  { displayName: 'Show 70 Rows', key: '70' },
  { displayName: 'Show 80 Rows', key: '80' },
  { displayName: 'Show 90 Rows', key: '90' },
  { displayName: 'Show 100 Rows', key: '100' }
];

export const defaultFilterOptions = [
  { key: 'sezSites', displayName: 'All' },
  { key: 'sezSites', displayName: 'Yes' },
  { key: 'sezSites', displayName: 'No' }
];

export const SEARCH_OTIONS_DI_VPN = [
  {
    key: 'gstNumber',
    displayName: 'GST Number',
    type: FILTER_TYPES.INPUT
  },
  {
    key: 'locationId',
    displayName: 'Site Id',
    type: FILTER_TYPES.INPUT
  }
];

export const SEARCH_OTIONS_ILL_UPGRADE = [
  {
    key: 'locationId',
    displayName: 'Site Id',
    type: FILTER_TYPES.INPUT
  }
];

export const SEARCH_OTIONS_NLD_LL = [
  {
    key: 'gstNumber',
    displayName: 'GST Number',
    type: FILTER_TYPES.INPUT
  },
  {
    key: 'linkId',
    displayName: 'Link ID',
    type: FILTER_TYPES.INPUT
  }
];

export const NLD_LL_HEADER_ORDER = [
  {
    headerName: 'Link ID',
    isSortable: true,
    sortKey: 'LOCATION_ID',
    sortValue: 'default'
  },
  {
    headerName: 'Site Type'
  },
  { headerName: 'Requested DOD' },
  { headerName: 'Installation Address' },
  { headerName: 'Billing Address' },
  { headerName: 'Shipping Address' },
  { headerName: 'GST Number' },
  {
    headerName: 'Total Price',
    isSortable: true,
    sortKey: 'TOTAL_PRICE',
    sortValue: 'default'
  },
  { headerName: 'GST Doc.' },
  { headerName: 'LOA Doc.' }
];

export const SITE_READINESS_HEADER_ORDER = [
  { headerName: 'Installation Address' },
  {
    headerName: 'Customer Need by Date'
  },
  { headerName: 'Site Readiness' },
  { headerName: 'Appoitnment Date & Time' },
  { headerName: 'Action' }
];

export const DI_VPN_HEADER_ORDER = [
  {
    headerName: 'Link ID',
    isSortable: true,
    sortKey: 'LOCATION_ID',
    sortValue: 'default'
  },
  { headerName: 'Installation Address' },
  { headerName: 'Customer Need by Date' },
  { headerName: 'Site Type' },
  { headerName: 'Billing Address' },
  { headerName: 'Shipping Address' },
  { headerName: 'GST Number' },
  {
    headerName: 'Total Price',
    isSortable: true,
    sortKey: 'TOTAL_PRICE',
    sortValue: 'default'
  },
  { headerName: 'GST Doc.' },
  { headerName: 'LOA Doc.' }
];

export const ILL_UPGRADE_HEADER_ORDER = [
  {
    headerName: 'Circuit ID',
    isSortable: true,
    sortKey: 'LOCATION_ID',
    sortValue: 'default'
  },
  { headerName: 'Estimated DOD' },
  { headerName: 'Installation Address' },
  { headerName: 'Billing Address' },
  { headerName: 'Site Contact Details' }
];

export const keyForGSTFiles = {
  GST_CERTIFICATE: 'filesForGSTCerificate',
  GST_LOA: 'filesForGSTLOA'
};
